import Link from 'next/link';
import clsx from 'clsx';
import { DownRightArrow } from '@/components/Icons';
import { BuildScanLogo } from '@/components/Logos';

type BuildScanButtonProps = {
  className?: string;
  innerClassName?: string;
};

export function BuildScanButton({ className, innerClassName }: BuildScanButtonProps) {
  return (
    <div className={clsx('flex gap-2', className)}>
      <DownRightArrow className="mt-1 size-6" />
      <Link
        href={'/scans'}
        scroll={false}
        className={clsx(
          innerClassName,
          'text-input-label flex w-full gap-2 whitespace-nowrap rounded-lg bg-gray-1 px-5 py-3 hover:outline hover:outline-gray-6',
        )}
      >
        <span>
          Run a <span className="gradle-gradient-text">FREE</span>
        </span>
        <BuildScanLogo className="w-24" />
      </Link>
    </div>
  );
}
